import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyB-PiuoO80wLuCOjonuKc1EPGeFaMP2qNk",
  authDomain: "skill-net.firebaseapp.com",
  databaseURL: "https://skill-net.firebaseio.com",
  projectId: "skill-net",
  storageBucket: "",
  messagingSenderId: "1084069072998"
};
firebase.initializeApp(config);



// WEBPACK FOOTER //
// ./src/firebase-config.js